import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { LoadingButton } from "components";
import { useNotification } from "hooks";
import { FC, useState } from "react";
import { tourneeService } from "services";
import { TourneeResource } from "types/transport.types";

export const ApprouverTournee: FC<{
  tournee: TourneeResource;
  onFinish: (tournee?: TourneeResource) => void;
  onClose: () => void;
}> = ({ tournee, onFinish, onClose }) => {
  const [starting, setStarting] = useState<boolean>(false);
  const notification = useNotification();

  const approuverPlanification = () => {
    setStarting(true);
    tourneeService
      .approuver(tournee.id)
      .then(({ data }) => {
        notification.success({
          title: "La tournée a été approuvée",
        });
        onFinish(data);
      })
      .catch((e) => {
        notification.warning({ title: e.message });
      })
      .finally(() => {
        setStarting(false);
        onClose();
      });
  };

  return (
    <Dialog maxWidth="sm" open onClose={onClose}>
      <DialogTitle>Approuver tournée</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Vous voulez vraiment approuver la planification de la tournée&nbsp;
          <Typography component="span" fontWeight={600}>
            {tournee.numero}
          </Typography>
          &nbsp;?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <LoadingButton
          variant="contained"
          onClick={approuverPlanification}
          autoFocus
          loading={starting}
          color="success"
        >
          Oui
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
